import React, {useState, useRef, useEffect} from 'react';
import emailjs from '@emailjs/browser';
import Alert from './Alert';

function Contact() {

  const formRef = useRef(null);
  const [form, setForm] = useState({name:'', email:'', message:''});
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    setForm({...form, [e.target.name]:e.target.value})
  } 

  const handleFocus = (e) => {

  }

  const handleBlur = (e) => {

  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const toSend = {
      from_name:form.name,
      to_name:"Ahmed",
      from_email:form.email,
      message:form.message
    }

    emailjs.send(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, toSend, process.env.REACT_APP_PUBLIC_KEY)
      .then(function(response) {
        setLoading(false);
        // console.log('SUCCESS!', response.status, response.text);
        setForm({name:'', email:'', message:''});
        setShowAlert(true);
      }, function(err) {
        console.log('FAILED...', err);
      });


  }

  useEffect(() => {
    let timer;
    if (showAlert) {
      timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000)
    }

    return () => clearTimeout(timer);
  }, [showAlert])

  return (
    <section className=' relative flex lg:flex-row flex-col max-container pt-24 bg-white h-full '>
      <div className='flex-1 min-w-[50%] flex flex-col'>
      {/* {showAlert && <Alert />}    */}
        <h1 className='font-bold text-3xl tracking-wide px-4'>Get in Touch</h1>
        <form className='w-full flex flex-col gap-7 mt-14'  onSubmit={handleSubmit}> 
          <label className='text-black-500 font-semibold flex flex-col mx-4 '>
            Name
            <input 
            type='text' 
            autoComplete='off'
            value={form.name} 
            onChange={handleChange} 
            onFocus={handleFocus}
            onBlur={handleBlur}
            name='name' 
            className='border-2 rounded-md border-brown shadow-sm border-solid mt-4 p-2' 
            placeholder=' John Frost' 

            required />
          </label>
          <label className='text-black-500 font-semibold flex flex-col mx-4 '>
            Email
            <input 
            autoComplete='off'

            type='email' 
            value={form.email} 
            onChange={handleChange} 
            onFocus={handleFocus}
            onBlur={handleBlur}
            name='email' 
            className='border-2 rounded-md border-brown shadow-sm border-solid mt-4 p-2' 
            placeholder=' john@gmail.com' 

            required />
          </label>
          <label className='text-black-500 font-semibold flex flex-col mx-4 '>
            Message
            <textarea 
            type='text' 
            rows={4}
            value={form.message} 
            onChange={handleChange} 
            onFocus={handleFocus}
            onBlur={handleBlur}
            name='message' 
            className=' border-2 rounded-md border-brown shadow-sm border-solid mt-4 p-2' 
            placeholder=' Let me know how I can help you!' 

            required />
          </label>
            {showAlert ? 
            <Alert /> :
          <div className='bg-indigo-900 text-white p-2 rounded-lg m-auto'>
             <button className='' type='submit' disabled={loading} onFocus={handleFocus} onBlur={handleBlur}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </div>
            }
        </form>
      </div>
    </section>
  )
}

export default Contact;